import { h } from "harmaja"
import * as L from "lonna"
import { FrameNavigator } from "./frames"

// Minimal overlay while presenting: frame title, position, prev/next/exit.
export const PresentationHud = ({ frames, current, presenting, next, prev, stopPresenting }: FrameNavigator) =>
    L.view(presenting, (p) =>
        !p ? null : (
            <div className="presentation-hud" onClick={(e) => e.stopPropagation()}>
                <a onClick={prev} title="Previous (←)">
                    ◀
                </a>
                <span className="title">
                    {L.view(frames, current, (fs, c) => (c >= 0 && fs[c] ? fs[c].text || "Untitled" : ""))}
                </span>
                <span className="position">{L.view(frames, current, (fs, c) => `${c + 1} / ${fs.length}`)}</span>
                <a onClick={next} title="Next (→ or Space)">
                    ▶
                </a>
                <a onClick={stopPresenting} title="Exit (Esc)">
                    ✕
                </a>
            </div>
        ),
    )
